import { ATC_BEELINE } from '@app/constants/socialIntegrationsTypes';

export const LEAD_MSG_TYPE_AUDIO = 'AUDIO';
export const LEAD_MSG_TYPE_VOICE = 'VOICE';
export const LEAD_MSG_TYPE_MISSING_CALL = 'MISSING_CALL';
export const LEAD_MSG_TYPE_CALL_OCCURRED = 'CALL_OCCURRED';
export const LEAD_MSG_TYPE_CALL_ANSWERED = 'CALL_ANSWERED';
export const LEAD_MSG_TYPE_CALL_RECORD_AWAITING = 'CALL_RECORD_AWAITING';
export const LEAD_MSG_TYPE_CALL_RECORD_WAITING = 'CALL_RECORD_WAITING';

const LEAD_CALL_MESSAGE_TYPES = new Set<string>([
  LEAD_MSG_TYPE_MISSING_CALL,
  LEAD_MSG_TYPE_CALL_OCCURRED,
  LEAD_MSG_TYPE_CALL_ANSWERED,
  LEAD_MSG_TYPE_CALL_RECORD_AWAITING,
  LEAD_MSG_TYPE_CALL_RECORD_WAITING,
]);

const LEAD_CALL_RECORD_LOADING_TYPES = new Set<string>([
  LEAD_MSG_TYPE_CALL_OCCURRED,
  LEAD_MSG_TYPE_CALL_ANSWERED,
  LEAD_MSG_TYPE_CALL_RECORD_AWAITING,
  LEAD_MSG_TYPE_CALL_RECORD_WAITING,
]);

export const isLeadAudioMessageType = (type: string | null): boolean =>
  type === LEAD_MSG_TYPE_AUDIO || type === LEAD_MSG_TYPE_VOICE;

export const isLeadCallMessageType = (type: string | null): boolean =>
  type !== null && LEAD_CALL_MESSAGE_TYPES.has(type);

export const isLeadMissingCallType = (type: string | null): boolean =>
  type === LEAD_MSG_TYPE_MISSING_CALL;

export const isLeadCallRecordLoadingType = (
  type: string | null,
  socialType: string | null,
  hasPlayableFile: boolean
): boolean =>
  !hasPlayableFile &&
  socialType === ATC_BEELINE &&
  type !== null &&
  LEAD_CALL_RECORD_LOADING_TYPES.has(type);
